export default __webpack_public_path__ + "static/media/facebook.11901db5.svg";